import React, { forwardRef, useState, useEffect, Fragment } from "react";
import FormItem from "antd/es/form/FormItem";
import Title from 'antd/es/typography/Title';
import { Col, Row, Typography, Button, Input } from 'antd';
import { Avatar } from 'antd';
import AvatarButton from 'ReusableComponents/AvatarButton/AvatarButton';
import cloneDeep from "lodash.clonedeep";
import TranslatedText from "translations/TranslatedText";
import Icon from "antd/es/icon/index";
import { Divider } from 'antd';

export default forwardRef((props: any, ref: any) => {
  const {
    disarrangedText: defaultDisarrangedText,
    language,
    onChange,
  } = props;
  const [disarrangedText, setDisarrangedText] = useState(defaultDisarrangedText)

  const setDisArranged = (value) => {
    const disarrangedTextClone = cloneDeep(disarrangedText)
    disarrangedTextClone.disarranged = value
    setDisarrangedText(disarrangedTextClone)
  }

  const setArranged = (value, index) => {
    const disarrangedTextClone = cloneDeep(disarrangedText)
    disarrangedTextClone.arranged[index] = value
    setDisarrangedText(disarrangedTextClone)
  }

  const addArranged = () => {
    const disarrangedTextClone = cloneDeep(disarrangedText)
    disarrangedTextClone.arranged.push('')
    setDisarrangedText(disarrangedTextClone)
  }

  const removeArranged = (index) => {
    const disarrangedTextClone = cloneDeep(disarrangedText)
    disarrangedTextClone.arranged.splice(index, 1)
    setDisarrangedText(disarrangedTextClone)
  }

  useEffect(() => {
    onChange(disarrangedText);
  }, [disarrangedText])

  return (
    <Fragment>
      <Divider orientation="center">
        <TranslatedText id={"settings.form.rearrangetext.disarranged.label"} />
      </Divider>
      <Row type="flex" justify="start" align="middle">
        <Col span={12}>
          <Input 
            value={disarrangedText.disarranged.hanzi}
            onChange={(event) => setDisArranged({
              hanzi: event.target.value,
              pinyin: disarrangedText.disarranged.pinyin
            })}
            addonBefore={<TranslatedText id={"settings.form.rearrangetext.hanzi.label"} />}
         />
        </Col>
        <Col span={12}>
          <Input
            value={disarrangedText.disarranged.pinyin}
            onChange={(event) => setDisArranged({
              hanzi: disarrangedText.disarranged.hanzi,
              pinyin: event.target.value
            })}
            addonBefore={<TranslatedText id={"settings.form.rearrangetext.pinyin.label"} />}
         />
        </Col>
      </Row>
      <Fragment>
        <Divider orientation="center">
          <TranslatedText id={"settings.form.rearrangetext.arranged.label"} />
        </Divider>
        {disarrangedText.arranged.map((text, index) => {
          return (
            <Fragment key={index}>
              <Row type="flex" justify="start" align="middle">
                <Col span={10}>
                  <Input
                    value={text.hanzi}
                    onChange={(event) => setArranged({
                      hanzi: event.target.value,
                      pinyin: disarrangedText.arranged[index].pinyin
                    }, index)}
                    addonBefore={<TranslatedText id={"settings.form.rearrangetext.hanzi.label"} />}
                 />
                </Col>
                <Col span={10}>
                  <Input
                    value={text.pinyin}
                    onChange={(event) => setArranged({
                      hanzi: disarrangedText.arranged[index].hanzi,
                      pinyin: event.target.value
                    }, index)}
                    addonBefore={<TranslatedText id={"settings.form.rearrangetext.pinyin.label"} />}
                 />
                </Col>
                <Col>
                  <Fragment>
                    <Button onClick={addArranged}>
                      <Icon type="plus-circle" />
                    </Button>
                    {disarrangedText.arranged.length > 1 && (
                      <Button onClick={()=>removeArranged(index)}>
                        <Icon type="minus-circle" />
                      </Button>
                    )}
                  </Fragment>
                </Col>
              </Row>
            </Fragment>
          )
        })}
      </Fragment>
    </Fragment>
  );
});
